import { createGenericFormSlice, SliceState } from "./genericFormSlice";

export interface EmailLoginCompletion {
  email: string | undefined;
}

const formSlice = createGenericFormSlice({
  name: "emailLoginCompletion",
  initialState: {} as SliceState<EmailLoginCompletion>,
  reducers: {},
});

export const { reset, initialize, updateField } = formSlice.actions;
const emailLoginCompletionFormReducer = formSlice.reducer;
export default emailLoginCompletionFormReducer;
